<template>
  <div>
    <nav-menu></nav-menu>

    <exibir-processando v-if="processando"/>

    <div class="w3-col w3-margin-top" style="font-size: 15px!important;">
      <div class="w3-col w3-padding-small">
        <label>Locais selecionados </label>

        <label class="link-vermelho" @click="definirLocais()">
          <span>(alterar)</span>
        </label>

        <label
          v-if="temLocalSelecionado"
          class="link-vermelho"
          @click="limparLocaisSelecionados()">
          <span>(limpar)</span>
        </label>
      </div>

      <label
        class="w3-col w3-padding-small"
        v-if="!temLocalSelecionado">Nenhum local foi selecionado
      </label>

      <div class="w3-padding-small">
        <strong
          :key="index"
          v-for="(local, index) in locaisSelecionados">
          <span v-show="index > 0">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span>{{local.local_id}} - {{local.nome}}</span>
        </strong>
      </div>
    </div>

    <div
      v-if="!this.mostrar_filtros"
      class="w3-col w3-padding-small">

      <label class="w3-col">Filtros selecionado</label>

      <strong>{{buscarTipoMovimentoAnalitico(tipo_movimento_selecionado)}}</strong>
      <strong v-if="movimento_selecionado_id">
        <span> - {{nPadrao(movimento_selecionado_id, 0)}}</span>
      </strong>

      <label class="link-vermelho" @click="mostrarOcultarFiltros()">
        <span>(alterar)</span>
      </label>

      <label
        v-if="tipo_movimento_selecionado != 'TOD'"
        class="link-vermelho"
        @click="limparFiltrosSelecionados()">
        <span>(limpar)</span>
      </label>
    </div>


    <div
      v-if="this.mostrar_filtros"
      class="w3-col l12 w3-padding-small">

      <div class="w3-margin-buttom  w3-col s12 l4">
        <label>Tipo de movimento</label>

        <select
          v-model="tipo_movimento_selecionado"
          ref="movimento"
          class="w3-input w3-border w3-select"
          style="height: 40px; width: 80%;"
          @change="movimento_selecionado_id = ''">

          <option value="ENT">Pedido</option>
          <option value="COR">Correção de estoque</option>
          <option value="DEC">Devolução de compra</option>
          <option value="CON">Remessa de conserto</option>
          <option value="OSA">Ordem de serviço</option>
          <option value="TRA">Transferência entre empresas</option>
          <option value="SEP">Separação para recebimento</option>
          <option value="TOD">Todos os movimentos</option>
        </select>
      </div>

      <div v-if="tipo_movimento_selecionado != 'TOD'">
        <div class="w3-half w3-col s8 l4">
          <label>Código do movimento</label>
          <input
            class="w3-input w3-border w3-left"
            style="width: 99%; height: 40px;"
            v-on:keyup.enter="processar()"
            type="number"
            placeholder="Código do movimento"
            v-model="movimento_selecionado_id"
            :disabled="tipo_movimento_selecionado == 'TOD'">
        </div>
      </div>

      <div
        class="w3-col s4 l4"
        style="margin-top:25px;"
        v-if="(tipo_movimento_selecionado != 'TOD')">

        <button
          class="w3-button w3-theme fa fa-camera"
          @click="abrirModalQrCode()">
        </button>
      </div>
    </div>

    <div class="w3-padding-small">
      <i
        v-if="this.mostrar_filtros"
        @click="mostrarOcultarFiltros()"
        style="font-size: 25px;"
        class="fas fa-chevron-up w3-center w3-col texto-vermelho">
      </i>

      <button
        class="w3-theme w3-button w3-col w3-margin-top"
        @click="processar()">Processar
      </button>
    </div>

    <div class="w3-col l12 s12 w3-padding-small">
      <div v-if="entregas && (entregas.length > 0) && total_entregas > movimentos_por_pagina">

        <div class="w3-col s12 m12 l12" style="text-align: center; margin-top: 20px;">

          <button
            class="w3-button w3-theme"
            :disabled="pagina_atual <= 1"
            @click="pagina_atual = 1">
            <i class="fas fa-angle-double-left"></i>
          </button>

          <button
            class="w3-button w3-theme"
            :disabled="pagina_atual <= 1"
            @click="pagina_atual = pagina_atual - 1">
            <i class="fas fa-angle-left"></i>
          </button>

          <span class="w3-text w3-right-align">
            {{pagina_atual}} / {{total_paginas}}
          </span>

          <button
            class="w3-button w3-theme"
            :disabled="pagina_atual >= total_paginas"
            @click="pagina_atual = pagina_atual + 1">
            <i class="fas fa-angle-right"></i>
          </button>

          <button
            class="w3-button w3-theme"
            :disabled="pagina_atual >= total_paginas"
            @click="pagina_atual = total_paginas">
            <i class="fas fa-angle-double-right"></i>
          </button>

        </div>
      </div>

      <div
        class="w3-panel w3-text-theme w3-bottombar w3-border-theme w3-border w3-animate-left"
        v-if="(!processando) && !entregas">

        <div class="w3-container w3-white" style="margin-bottom: 0 !important">
          <p>Nenhum movimento foi encontrado.</p>
        </div>
      </div>

      <div
        class="w3-border w3-col active card-pedido w3-margin-top w3-padding-small"
        v-for="entrega in entregas"
        :key="entrega.indice"
        :style="estiloCardConfirmado(entrega)"
        v-show="(
          (entrega.indice >= pagina_atual * movimentos_por_pagina - movimentos_por_pagina) &&
          (entrega.indice < pagina_atual * movimentos_por_pagina)
        )">

        <div class="w3-col s12 m6 w3-left">
          <strong :class="getClasseTipoMovimento(entrega.tipo, entrega.mostrar)">
            <span>{{getDescricaoTipoMovimento(entrega.tipo)}}: </span>
            <span>{{entrega.movimento_id}}</span>
          </strong>
        </div>

        <div class="w3-col s12 m6">
          <strong class="texto-vermelho" v-if="(entrega.orcamento_id > 0)">Pedido </strong>

          <strong class="texto-vermelho" v-if="(entrega.orcamento_id > 0)">
            <span>{{entrega.orcamento_id}}</span>
          </strong>

          <label class="w3-right" v-if="(entrega.orcamento_id > 0)">
            <span>{{entrega.data_entrega}}</span>
          </label>
          <span v-if="entrega.orcamento_id <= 0">&nbsp;</span>
        </div>

        <div class="w3-col s12 m12 w3-left">
          <legenda>
            <div>Nome do cliente</div>
            <i slot="referencia" class="fa fa-user-tie texto-vermelho"></i>
          </legenda>
          <strong>{{getNomeCliente(entrega)}}</strong>
        </div>

        <div class="w3-col s12 m6 w3-left">
          <legenda v-if="entrega.nome_vendedor">
            <div>Nome do vendedor</div>
            <i slot="referencia" class="fa fa-user-tag texto-vermelho"></i>
          </legenda>
          <label v-if="entrega.nome_vendedor">&nbsp;&nbsp;&nbsp;{{entrega.nome_vendedor}}</label>
        </div>

        <div
          class="w3-col s12 m6 w3-left"
          v-if="(entrega.nome_local) && (entrega.nome_local.length > 1) && (tipo_movimento_selecionado == 'TOD')">
          
          <legenda>
            <div>Nome do local</div>
            <i slot="referencia" class="fas fa-warehouse texto-vermelho"></i>
          </legenda>
          
          <label>&nbsp;&nbsp;{{entrega.local_id}} - {{entrega.nome_local}}</label>
        </div>

        <div class="w3-col s12 m6 w3-left" v-if="entrega.entrega_no_ato">
          <label
            v-bind:class="getClasseSimNao(entrega.entrega_no_ato, false)"
            v-if="entrega.entrega_no_ato == 'S'">
            <span>Entrega no Ato</span>
          </label>
        </div>

        <div class="w3-col s12 m6 w3-left" v-if="entrega.imprimiu_lista_sep">
          <label
            v-bind:class="getClasseSimNao(entrega.imprimiu_lista_sep, false)"
            v-if="entrega.imprimiu_lista_sep == 'N'">
            <i class="fas fa-times texto-vermelho">&nbsp;</i>
            <span class="texto-vermelho">Não imprimiu "lista separação."</span>
          </label>

          <label
            v-bind:class="getClasseSimNao(entrega.imprimiu_lista_sep, false)"
            v-if="entrega.imprimiu_lista_sep == 'S'">
            <i class="fas fa-check" style="color:#4CAF50">&nbsp;</i>
            <span class="texto-verde" style="color:#4CAF50">
              <span>Imprimiu "lista separação."</span>
            </span>
          </label>
        </div>

        <div
          v-if="!entrega.mostrar"
          class="w3-col"
          style="padding: 15px 0 10px 0">

          <strong
            class="link-vermelho"
            @click="mostrarOcultarItensMovimento(entrega.tipo, entrega.movimento_id)">
            <span>Ver itens <i class="fas fa-angle-double-right"></i></span>
          </strong>
        </div>

        <div
          v-if="entrega.mostrar"
          class="w3-col"
          style="padding: 15px 0 10px 0">

          <div
            :key="index"
            v-for="(item, index) in entrega.itens"
            class="w3-container w3-margin-bottom"
            style="background-color: #dddddd; border-radius: 10px;">

            <div class="w3-col">
              <strong>Item {{index + 1}}</strong>
            </div>

            <div class="w3-col">
              <label>Produto:</label>
              <strong>{{item.produto_id}} - {{item.nome}}</strong>
            </div>

            <div class="w3-col s12 m6 l4">
              <label>Quantidade:</label>
              <strong>{{item.quantidade}} ({{item.unidade}})</strong>
            </div>

            <div class="w3-col s12 m6 l4" v-show="item.codigo_original">
              <label>Código original:</label>
              <strong>{{item.codigo_original}}</strong>
            </div>

            <div class="w3-col s12 m6 l4" v-if="item.marca">
              <label>Marca:</label>
              <strong>{{item.marca}}</strong>
            </div>

            <div class="w3-col s12 m6 l4" v-if="item.multiplo_venda != '1,000'">
              <label>Múltiplo de venda:</label>
              <strong>{{item.multiplo_venda}}</strong>
            </div>

            <div class="w3-col s12 m6 l4" v-if="item.previsao_entrega">
              <label>Previsão de entrega:</label>
              <strong>{{item.previsao_entrega}}</strong>
            </div>

            <div class="w3-col s12 m6 l4" v-if="item.tipo_controle_numero_serie != 'N'">
              <label>Controle de número de série:</label>
              <strong>{{getTipoControleNumeroSerie(item.tipo_controle_numero_serie)}}</strong>
            </div>
          </div>

          <strong
            class="link-vermelho"
            @click="mostrarOcultarItensMovimento(entrega.tipo, entrega.movimento_id)">
            <span><i class="fas fa-angle-double-left"></i> Ocultar itens</span>
          </strong>
        </div>

        <div class="w3-col" style="padding: 15px 0 10px 0">
          <button
            class="w3-button w3-theme"
            @click="confirmarEntrega(entrega)">
            <span><i class="fas fa-check"></i> Confirmar</span>
          </button>
        </div>
      </div>
      
      <div v-if="entregas && total_entregas > movimentos_por_pagina">
        <div class="w3-col s12 m12 l12" style="text-align: center; margin-top: 20px;">

          <button
            class="w3-button w3-theme"
            :disabled="pagina_atual <= 1"
            @click="pagina_atual = 1">
            <i class="fas fa-angle-double-left"></i>
          </button>

          <button
            class="w3-button w3-theme"
            :disabled="pagina_atual <= 1"
            @click="pagina_atual = pagina_atual - 1">
            <i class="fas fa-angle-left"></i>
          </button>

          <span class="w3-text w3-right-align">
            {{pagina_atual}} / {{total_paginas}}
          </span>

          <button
            class="w3-button w3-theme"
            :disabled="pagina_atual >= total_paginas"
            @click="pagina_atual = pagina_atual + 1">
            <i class="fas fa-angle-right"></i>
          </button>

          <button
            class="w3-button w3-theme"
            :disabled="pagina_atual >= total_paginas"
            @click="pagina_atual = total_paginas">
            <i class="fas fa-angle-double-right"></i>
          </button>

        </div>
      </div>
    </div>

    <modal-locais
      ref="modal_locais"
      :multiSelecao="locais_multi_selecao"
      :locaisSelecionadosIds="locais_selecionados_ids"
      @confirmar="confirmarSelecaoLocais">
    </modal-locais>

    <modal-conferencia
      ref="modal_conferencia"
      :tipoConfirmacao="configuracoes.par_emp_tipo_confirmacao_conferen_ent"
      :utilizaBalanca="configuracoes.par_geral_utiliza_balanca"
      @confirmar="confirmarConferencia">
    </modal-conferencia>

    <modal-assinatura
      ref="modal_assinatura"
      @confirmar="confirmarAssinatura">
    </modal-assinatura>

    <modal-autorizacao
      modo="CER"
      chave="confirmar_entrega_ato_ou_nao_controlam_manifesto"
      descricaoAutorizacao="confirmar entregas no ato ou que não controlam manifestos"
      ref="modalAutorizacao"
      @confirmarAutorizacao="confirmarAutorizacao">
    </modal-autorizacao>

    <modal-code
      v-if="mostrar_modal_qr_code"
      @atualizar="processarQrCode"
      @close="mostrar_modal_qr_code = false">
    </modal-code>

    <coletar-pessoa-saida-produtos
      ref="modal_coletar_pessoa_saida_produtos"
      :exigirIdentificacaoCompleta="configuracoes.par_emp_exig_identif_comp_conf_entrega"
      @confirmar="confirmarColetaPessoaSaidaProdutos">
    </coletar-pessoa-saida-produtos>
  </div>
</template>

<script>
  import moment from 'moment';
  import formatarValorMixin from '@/mixins/formatarValorMixin';
  import NavMenu from '@/components/Menu';
  import VueNumeric from 'vue-numeric';
  import ModalCode from '@/components/ModalQrCode';
  import ModalAssinatura from '@/components/ModalAssinatura';
  import ModalLocais from '@/components/ModalLocais';
  import ModalConferencia from '@/components/ModalConferencia';
  import Legenda from '@/components/Legendas';
  import toastr from 'toastr';
  import REntrega from '@/components/Rest/REntrega.js';
  import RSessao from '@/components/Rest/RSessao';
  import RLocalProduto from '@/components/Rest/RLocalProduto';
  import Biblioteca from '@/components/Repositorio/Biblioteca';
  import ModalAutorizacao from '@/components/Autorizar';
  import ExibirProcessando from '@/components/ExibirProcessando'
  import ColetarPessoaSaidaProdutos from '@/components/ColetarPessoaSaidaProdutos';

  export default {
    name: 'ConfirmarSaidaProdutos',

    components: {
      NavMenu,
      moment,
      VueNumeric,
      ModalAssinatura,
      ModalLocais,
      ModalConferencia,
      ModalCode,
      Legenda,
      ModalAutorizacao,
      ExibirProcessando,
      ColetarPessoaSaidaProdutos
    },

    mixins:[formatarValorMixin],

    data() {
      return {
        configuracoes: {},
        
        locais_multi_selecao: 'N',
        locais_selecionados_ids: [],
        pode_alterar_local: true,
        todos_locais: [],

        mostrar_filtros: true,
        tipo_movimento_selecionado: 'TOD',
        movimento_selecionado_id: '',

        entregas: [],
        quantidade_a_confirmar: 0,

        total_entregas: 0,
        total_paginas: 0,
        movimentos_por_pagina: 5,
        pagina_atual: 0,

        usuario_autorizacao_id: undefined,
        movimento_selecionado: {},

        result: '',
        lista_itens_verificados: [],
        autorizacoes: {},
        processando: false,
        mostrar_modal_assinatura: false,
        mostrar_modal_conferencia: false,
        mostrar_modal_qr_code: false,
        locais_adicionados: [],
        selecionar_todos_locais: false,
        
        tipo: '',
        movimento_id: '',
        produtos_filtrados: [],
        lista_resultado: [],

        movimentos: [
          {
            'nome': 'Entrega',
            'tipo': 'ENT'
          },
          {
            'nome': 'Correção de estoque',
            'tipo': 'COR'
          },
          {
            'nome': 'Devolução de compra',
            'tipo': 'DEC'
          },
          {
            'nome': 'Remessa para conserto',
            'tipo': 'CON'
          },
          {
            'nome': 'Ordem de serviço',
            'tipo': 'OSA'
          },
          {
            'nome': 'Transferência entre empresas',
            'tipo': 'TRA'
          },
          {
            'nome': 'Separação para recebimento',
            'tipo': 'SEP'
          },
          {
            'nome': 'Retirar lojas rede imediatamente',
            'tipo': 'RLI'
          },
        ]
      }
    },

    methods: {
      confirmarSelecaoLocais(locais_ids) {
        this.locais_selecionados_ids = JSON.parse(JSON.stringify(locais_ids));

        for (let i = 0; i < this.todos_locais.length; i++) {
          this.todos_locais[i].selecionado = false;

          for (let j = 0; j < locais_ids.length; j++) {
            if (this.todos_locais[i].local_id != locais_ids[j]) {
              continue;
            }

            this.todos_locais[i].selecionado = true;
            break;
          }
        }

        this.todos_locais = JSON.parse(JSON.stringify(this.todos_locais));
      },

      definirLocais() {
        this.locais_selecionados_ids = [];
        for (let i = 0; i < this.todos_locais.length; i++) {
          if (this.todos_locais[i].selecionado) {
            this.locais_selecionados_ids.push(this.todos_locais[i].local_id)
          }
        }

        this.$refs.modal_locais.abrir();
      },

      getTipoControleNumeroSerie(tipo_controle_numero_serie) {
        if (tipo_controle_numero_serie == 'N') {
          return 'Nenhum';
        }
        else if (tipo_controle_numero_serie == 'S') {
          return 'Saída';
        }
        else if (tipo_controle_numero_serie == 'T') {
          return 'Entrada e saída'
        }
      },

      limparLocaisSelecionados() {
        this.locais_selecionados_ids = [];
        for (let i = 0; i < this.todos_locais.length; i++) {
          this.todos_locais[i].selecionado = false;
        }

        this.todos_locais = JSON.parse(JSON.stringify(this.todos_locais));
      },

      limparFiltrosSelecionados() {
        this.tipo_movimento_selecionado = 'TOD';
        this.movimento_selecionado_id = '';        
      },

      mostrarOcultarItensMovimento(tipo, movimento_id) {
        for (let i = 0; i < this.entregas.length; i++) {
          if (this.entregas[i].tipo != tipo) {
            continue;
          }

          if (this.entregas[i].movimento_id != movimento_id) {
            continue;
          }

          this.entregas[i].mostrar = !this.entregas[i].mostrar;
          break;
        }

        this.entregas = JSON.parse(JSON.stringify(this.entregas));
      },

      confirmarAutorizacao(usuario_id) {
        this.usuario_autorizacao_id = undefined;
        this.configuracoes = JSON.parse(JSON.stringify(this.configuracoes));

        if (
          (this.movimento_selecionado.tipo == 'ENT') ||
          (this.movimento_selecionado.tipo == 'COR') ||
          (this.movimento_selecionado.tipo == 'DEC') ||
          (this.movimento_selecionado.tipo == 'CON') ||
          (this.movimento_selecionado.tipo == 'SEP')
        ) {
          this.$refs.modal_conferencia.abrir(this.movimento_selecionado.itens);
          return;
        }

        /* Se não tiver tela de confirmação, pelo menos questionar */
        swal(
          'Deseja confirmar de saída do movimento selecionado?', 
          {
            buttons: {
              nao: 'Não',
              sim: 'Sim',
            },
          }
        )
        .then(
          (value) => {
            switch (value) {
              case 'sim':
                this.$refs.modal_assinatura.abrir();
                break;
            }
          }
        );
      },

      confirmarConferencia(itens) {
        this.movimento_selecionado.itens = JSON.parse(JSON.stringify(itens));
        this.$refs.modal_assinatura.abrir();
      },

      confirmarAssinatura(dados_assinatura) {
        this.movimento_selecionado.assinatura_digital = dados_assinatura;
        
        let coletar_documentos = false;
        if (this.movimento_selecionado.tipo == 'ENT') {
          coletar_documentos = this.configuracoes.par_emp_exig_identif_comp_conf_entrega == 'S';
        }

        this.$refs.modal_coletar_pessoa_saida_produtos.abrir(
          coletar_documentos,
          this.movimento_selecionado.nome,
          this.movimento_selecionado.rg,
          this.movimento_selecionado.orgao_expedidor,
          this.movimento_selecionado.placa
        );
      },

      confirmarColetaPessoaSaidaProdutos(dados_pessoa_recebeu) {
        this.movimento_selecionado.nome = dados_pessoa_recebeu.nome;
        this.movimento_selecionado.rg = dados_pessoa_recebeu.rg;
        this.movimento_selecionado.orgao_expedidor = dados_pessoa_recebeu.orgao_expedidor;
        this.movimento_selecionado.placa = dados_pessoa_recebeu.placa;

        this.confirmarSaidaProdutos('CONFIRMAR_CONFERENCIA');
      },

      async confirmarEntrega(entrega) {
        this.movimento_selecionado = JSON.parse(JSON.stringify(entrega));

        /* ---------- Estabelecemos um 'ID' para o item pois o item_id não é único. ---------- */
        /* ---------- Ele se repete quando o produto_id se repete (lote diferente) ----------- */
        for (let i = 0; i < this.movimento_selecionado.itens.length; i++) {
          this.movimento_selecionado.itens[i].indice = i;
        }

        let retorno = await this.confirmarSaidaProdutos('VERIFICACAO');

        if (!retorno){
          return;
        }

        this.$refs.modalAutorizacao.abrir();
      },

      async confirmarSaidaProdutos(tipoOperacao) {
        try {
          let entrega_no_ato = 'N';
          if (this.movimento_selecionado.entrega_no_ato) {
            entrega_no_ato = this.movimento_selecionado.entrega_no_ato;
          }

          let parametros = {
            tipo_operacao: tipoOperacao,
            local_id: this.movimento_selecionado.local_id,
            movimento_id: this.movimento_selecionado.entrega_id,
            orcamento_id: this.movimento_selecionado.orcamento_id,
            tipo_movimento: this.movimento_selecionado.tipo,
            baixa_entrega_id: this.movimento_selecionado.baixa_entrega_id,
            entrega_no_ato: entrega_no_ato,
            passivel_confirmacao: this.movimento_selecionado.passivel_confirmacao,
            movimento_id: this.movimento_selecionado.movimento_id,
            assinatura_digital: this.movimento_selecionado.assinatura_digital,
            recebedor_entrega_nome: this.movimento_selecionado.nome,
            recebedor_entrega_rg: this.movimento_selecionado.rg,
            recebedor_entrega_orgao_expedidor: this.movimento_selecionado.orgao_expedidor,
            recebedor_entrega_placa_veiculo: this.movimento_selecionado.placa,
            produtos_conferencia: this.movimento_selecionado.itens
          }

          let retorno = await REntrega.confirmarSaidaProdutos(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          if (tipoOperacao == 'VERIFICACAO'){
            return true;
          }

          if (retorno.dados.notas_pendentes_emissao) {
            let notas = '';
            let notas_pendente = '';

            for (let i = 0; i < retorno.dados.notas_pendentes_emissao.length; i++) {
              notas += retorno.dados.notas_pendentes_emissao[i];
              if (i < retorno.dados.notas_pendentes_emissao.length - 1) {
                notas += ', ';
              }
            }
            
            notas_pendente = 
              'Não foi possível emitir a NF-e automaticamente. ' +
              'Envie-a pelo programa de gerenciamento de NF-e! ' + 
              'NF-e: ' + notas;
          
            swal('Saída de produto confirmada!', notas_pendente, 'success', {
              buttons: {
                ok: 'Ok',
              },
            })
            .then((value) => {
              switch (value) {
                case 'ok':
                  this.processar();
              }
            })
          }
          else {
            toastr.info('Operação realizada com sucesso.');
            this.processar();
          }
        }
        catch (erro) {
          swal(erro.message);
          return false;
        }
      },

      nPadrao(numero, casas_decimais) {
        return Biblioteca.nPadrao(numero, casas_decimais);
      },
 
      estiloCardConfirmado(resultado) {
        if(resultado.passivel_confirmacao === 'N') {
          return 'background-color: #ddd;';
        }
      },

      getClassePaginaAtiva(numeroDaPagina) {
        if(this.pagina_atual == numeroDaPagina) {
          return 'w3-button w3-theme';
        }
        else {
          return 'w3-button';
        }
      },

      mudarPagina: function(numeroDaPagina) {
        this.$emit('pagina', numeroDaPagina);
      },

      atualizalocais_selecionados_ids(e) {
        this.locais_selecionados_ids.push(e);
      },

      mudarPagina(numeroDaPagina) {
        this.pagina_atual = numeroDaPagina;
      },

      mostrarOcultarItens(index, condicional) {
        this.$set(index, 'mostrar', condicional);
      },

      mostrarOcultarFiltros() {
        this.mostrar_filtros = !this.mostrar_filtros;
      },

      abrirModalQrCode() {
        this.mostrar_modal_qr_code = true;
      },

      abrirModalAssinatura(produtos_confirmacao, lista_itens_verificados) {
        this.produtos_confirmacao = produtos_confirmacao;
        this.lista_itens_verificados = lista_itens_verificados;
        this.mostrar_modal_assinatura = true;
      },

      abrirModalConferencia() {
        for (let i = 0; i < this.itens_conferencia.itens.length; i++) {
          if (this.itens_conferencia.itens[i].verificado != false) {
            this.$set(this.itens_conferencia.itens[i], 'verificado', false);
          }
        }

        this.mostrar_modal_assinatura = false;
        this.mostrar_modal_conferencia = true;
      },

      async buscarDadosIniciais() {
        try {
          let retorno = await RLocalProduto.buscarTodosLocaisProdutos(this.axios);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }
          this.todos_locais = JSON.parse(JSON.stringify(retorno.dados))
          for (let i = 0; i < this.todos_locais.length; i++) {
            this.todos_locais[i].selecionado = false;
          }

          retorno = await RSessao.buscarDadosIniciaisTelaConfirmacaoSaidaProdutos(
            this.axios
          );
          if (retorno.houve_erro != 'N') {
            throw new Error(this.configuracoes.mensagem);
          }
          this.configuracoes = JSON.parse(JSON.stringify(retorno.dados));


          /* Igual na tela de confirmação de saída de produtos */
          if (this.todos_locais.length == 1) {
            this.todos_locais[0].selecionado = true;
            this.pode_alterar_local = false;
          }
          else if (
            (this.configuracoes.local_id > 0) && 
            (this.configuracoes.par_emp_hab_busc_aut_conf_ent_ato == 'S')
          ) {
            for (let i = 0; i < this.todos_locais.length; i++) {
              if (this.todos_locais[i].local_id == this.configuracoes.local_id) {
                this.todos_locais[i].selecionado = true;
                break;
              }
            }

            this.pode_alterar_local = false;
          }


          if (this.configuracoes.par_emp_permitir_multisel_conf_entrega == 'S') {
            this.locais_multi_selecao = 'S';
          }


          if (!this.temLocalSelecionado) {
            this.definirLocais();
          }
        }
        catch (erro) {
          toastr.error(erro.message);
        }
      },

      getDescricaoTipoMovimento(tipo) {
        for (let i = 0; i < this.movimentos.length; i++) {
          if (this.movimentos[i].tipo == tipo) {
            return this.movimentos[i].nome;
          }
        }

        return 'Indefinido';
      },

      getNomeCliente(entrega) {
        if (entrega.nome_usuario_requisicao) {
          return entrega.nome_usuario_requisicao + ' (' + entrega.nome_cliente + ')';
        }
        else {
          return entrega.nome_cliente;
        }
      },

      getClasseTipoMovimento(tipo) {
        if (tipo == 'ENT') {
          return 'w3-green';
        }
        else if (tipo == 'COR') {
          return 'w3-amber';
        }
        else if (tipo == 'DEC') {
          return 'w3-indigo';
        }
        else if (tipo == 'CON') {
          return 'w3-purple';
        }
        else if (tipo == 'OSA') {
          return 'w3-brown';
        }
        else if (tipo == 'TRA') {
          return 'w3-orange';
        }
        else if (tipo == 'SEP') {
          return 'w3-blue';
        }
        else if (tipo == 'RLI') {
          return 'w3-purple';
        }
      },

      getClasseSimNao(tipo, mostrar){
        if (mostrar) {
          return 'w3-theme';
        }

        if (tipo == 'S') {
          return 'cor_texto_sim';
        }
        
        return 'cor_texto_nao';
      },

      simNaoString(sn) {
        return Biblioteca.simNaoString(sn);
      },

      async processar() {
        try {
          if ((!this.temLocalSelecionado) && (this.movimento_selecionado_id == '')) {
            this.mostrar_filtros = true;          
            toastr.error('O local ou o código do movimento!');
            return;
          }

          this.processando = true;
          this.ja_processou = true;

          this.lista_resultado = {};

          let parametros = {
            locais_ids: this.locais_selecionados_ids,
            movimento_id: this.movimento_selecionado_id,
            tipo_movimento: this.tipo_movimento_selecionado
          }

          let retorno = await REntrega.buscarItensConfirmacaoSaidaProdutos(
            this.axios,
            parametros
          );

          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.mostrar_filtros = false;
          this.quantidade_a_confirmar = retorno.dados.quantidade_a_confirmar;

          this.entregas = JSON.parse(JSON.stringify(retorno.dados.entregas));
          for (let i = 0; i < this.entregas.length; i++) { 
            this.entregas[i].indice = i;
            for (let j = 0; j < this.locaisSelecionados.length; j++) {
              if (this.entregas[i].local_id == this.locaisSelecionados[j].local_id) {
                this.entregas[i].nome_local = this.locaisSelecionados[j].nome;   
              }
            }
          }

          this.total_entregas = this.entregas.length;
          this.total_paginas = Math.ceil(this.entregas.length / this.movimentos_por_pagina);
          this.pagina_atual = 1;

          this.processando = false;
        }
        catch (erro) {
          this.processando = false;

          this.entregas = [];

          this.pagina_atual = 1;
          this.total_paginas = 1;
          this.total_entregas = 0;
          this.quantidade_a_confirmar = 0;

          toastr.error(erro.message);
        }
      },

      processarQrCode(result) {
        this.movimento_selecionado_id = result;
        this.tipo_movimento_selecionado = 'ENT';
        this.processar();
      },

      mostrarOcultarModalLocais() {
        if (this.locais_selecionados_ids.length == 0) {
          this.mostrarModalLocais = true;
        }
      },

      buscarTipoMovimentoAnalitico(tipo) {
        if (!tipo) {
          return;
        }

        if (tipo == 'TOD') {
          this.nome_movimento = 'Todos';
          return this.nome_movimento;
        }
        else if (tipo == 'SEP') {
          this.nome_movimento = 'Separação para recebimento';
          return  this.nome_movimento;
        }
        else if (tipo == 'TRA') {
          this.nome_movimento = 'transferência entre empresas';
          return  this.nome_movimento;
        }
        else if (tipo == 'OSA') {
          this.nome_movimento = 'Ordem de serviço';
          return  this.nome_movimento;
        }
        else if (tipo == 'CON') {
          this.nome_movimento = 'Remessa conserto';
          return this.nome_movimento;
        }
        else if (tipo == 'DEC') {
          this.nome_movimento = 'Devolucao de Compra';
          return this.nome_movimento;
        }
        else if (tipo == 'COR') {
          this.nome_movimento = 'Correção de estoque';
          return  this.nome_movimento;
        }
        else if (tipo == 'ENT') {
          this.nome_movimento = 'Pedido';
          return  this.nome_movimento;
        }
      }
    },

    computed: {
      temLocalSelecionado() {
        if (!this.todos_locais) {
          return false;
        }

        for (let i = 0; i < this.todos_locais.length; i++) {
          if (this.todos_locais[i].selecionado) {
            return true;
          }
        }

        return false;
      },

      locaisSelecionados() {
        if (!this.todos_locais) {
          return [];
        }

        let retorno = [];
        for (let i = 0; i < this.todos_locais.length; i++) {
          if (this.todos_locais[i].selecionado) {
            retorno.push(JSON.parse(JSON.stringify(this.todos_locais[i])));
          }
        }

        return retorno;
      },

      resultadosExibidosNaTela: function() {
        if((this.pagina_atual + 1) != this.total_paginas) {
          return (this.pagina_atual + 1) * this.movimentos_por_pagina;
        }
        else {
          return this.total_entregas;
        }
      },

      getfiltro_movimento() {
        let retorno;
        for(let i = 0; i < this.filtrosMovimento.length ; i++ ) {
          retorno = parseString(this.filtrosMovimento[i]);
        }
        return retorno;
      },

      novosPedidosFiltrados() {
        if (!this.entregas) {
          return [];
        }

        this.total_entregas = this.entregas.length;
        this.total_paginas =  Math.ceil(this.total_entregas / this.movimentos_por_pagina);

        if (this.pagina_atual >= this.total_paginas) {
          this.pagina_atual = this.total_paginas;
        }

        var index = this.pagina_atual * this.movimentos_por_pagina;
        return this.lista_resultado.entregas.slice(index, index + this.movimentos_por_pagina);
      }
    },

    mounted() {
      if (this.locais_selecionados_ids.length > 0) {
        this.processar();
      }

      this.$root.$on(
        'abrirModalConferencia', 
        (itens) => {
          this.itens_conferencia = itens;
          this.abrirModalConferencia();
        }
      )

      this.$root.$on('abrirModalAssinatura', (lista_itens_verificados, produtos_confirmacao) => {
        this.abrirModalAssinatura(lista_itens_verificados, produtos_confirmacao)
      })

      this.$root.$on('abrirModalQrCode',() => {
        this.abrirModalQrCode()
      })

      this.$root.$on('processar', (itens) => {
        this.processar();
      })

      this.produtos_filtrados = this.lista_resultado
      $('html,body').stop().animate(
        {scrollTop: 0},
        'slow',
        'swing'
      );
    },

    created() {
      this.buscarDadosIniciais();
      this.mostrarOcultarModalLocais();
    },

    filters: {
      uppercase: function(value, onlyFirstCharacter) {
        if (!value) {
          return '';
        }

        value = value.toString();

        if (onlyFirstCharacter) {
          return value.toLowerCase().split(' ').map(
            (s) => s.charAt(0).toUpperCase() + s.substring(1)
          ).join(' ');
        }
        else {
          return value.toUpperCase();
        }
      }
    }
  }
</script>

<style scoped>
  .item-local {
    padding: 6px;
    border: 1px solid #999999;
    margin: 2px;
    border-radius: 10px;
  }

  .link-vermelho {
    color: #9c1d1c;
    text-decoration: underline;
  }

  .card-pedido {
    border-radius: 10px;
    box-shadow: #dddddd 1px 3px 5px 3px ;
  }

  .item-confirmado {
    color: grey
  }

  .card-informacoes {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    float: left;
    padding: 7px;
    border-bottom-color: #636363 !important;
    cursor: pointer;
    transition: 0.2s;
    width: 100%
  }

  .card-informacoes:hover {
    background: #eeeeee;
  }

  .table-mapa-financeiro {
    border: 1px solid #f1f1f1f1;
    padding-left: 0px;
    padding-right: 0px;
  }

  .tr-itens:hover {
    background: #9c1d1c;
    color:#fff;
    cursor: pointer;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .tr-itens-ativo:hover {
    background: #9c1d1c;
    color: white;
  }

  .tr-itens-ativo {
    background: #9c1d1c;
    color: white;
  }

  .tabale-aberta {
    background: #9c1d1c;
    color: white;
  }

  .tr-titulo, .resultado-titulo {
    padding: 10px !important;
    background: #565454b8;
    color:white;
  }

  .pesquisar-titulo {
    margin: auto;
    text-align: center;
    cursor: pointer;
    border: #636363 1px solid;
    padding: 10px;
    transition: 0.1s;
    background: #9c1d1c;
    color: white;
  }

  .pesquisar-titulo:hover {
    background: white;
    color: black
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .processar-btn {
    margin-top: 10px;
    padding: 5px 
  }

  .container-radio {
    text-align: left;
    padding: 10px;
    margin: auto;
    cursor: pointer;
    transition: 0.2s;
    margin-left: 10px;
    margin-right: 10px;
    text-align: center;
  }

  .container-radio:hover {
    color:#9c1d1c;
    background: #f1f1f1;
  }

  .movimento-selecionado {
    background: #9c1d1c;
    color: white;
  }

  ul {
    list-style: none;
  }

  .tr-itens {
    white-space: nowrap;
  }

  th {
    white-space: nowrap;
  }

  .card-item {
    margin-top: 0 !important;
  }

  .lista-marcados {
    text-align: center;
    border-left: 1px solid #ccc;
    padding: 5px;
    margin-top:10px;
    white-space: nowrap;
  }

  .container-marcados {
    max-width: 100%;
    padding: 10px;
    overflow: auto;
    border: 1px solid #ccc;
  }

  .cor_texto_sim {
    color: blue;
  }

  .cor_texto_nao {
    color: red;
  }

  .w3-table td {
    padding: 4px 8px;
  }

  .w3-input-half > .w3-half:first-of-type {
    padding-left: 0 !important;
  }

  .w3-input-half > .w3-half:nth-child(2) {
    padding-right: 0 !important;
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd;
  }

  ::-webkit-scrollbar-thumb {
    background: #8d1007;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c;
  }

  @media screen and (max-width: 767px) {
    .w3-input-half > .w3-half:first-of-type,.w3-input-half > .w3-half:nth-child(2) {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ConfirmarSaidaProdutos.vue